import _ from 'lodash';
import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { getSystem } from './system.selectors';

export const selectSystemTags = createSelector(getSystem, ({ tags }) => tags);

export const selectSystemTagsValues = createSelector(selectSystemTags, Object.values);

export const selectSystemTagsOptions = memoizeOne(
  ({ withDeleted }) =>
    createSelector(selectSystemTagsValues, tags =>
      tags.reduce((acc, { name, tagId, isDeleted, isGlobal }) => {
        if (!withDeleted && isDeleted) {
          return acc;
        }

        acc.push({
          name: `${name}${isDeleted ? ' (Deleted)' : ''}`,
          value: tagId,
          isDeleted,
          isGlobal,
        });

        return acc;
      }, []),
    ),
  _.isEqual,
);

export const selectFilteredSystemTags = createSelector(
  getDebouncedSearchValue,
  selectSystemTagsValues,
  searchItems(({ name }) => [name]),
);
